<i18n
  src="@/i18n/components/segmented-trends/segmented-trends-web-view-table.json"
></i18n>
<template>
  <AnalysisTable
    class="segmented-trends-web-view-table"
    data-cy="segmented-trends-web-view-table"
  >
    <template #header>
      <AnalysisTableHeaderRow>
        <AnalysisTableHeaderCell width="50%">{{
          $t("url")
        }}</AnalysisTableHeaderCell>
        <AnalysisTableHeaderCell>{{ $t("pv") }}</AnalysisTableHeaderCell>
        <AnalysisTableHeaderCell>{{ $t("pvVisit") }}</AnalysisTableHeaderCell>
        <AnalysisTableHeaderCell>
          {{ $t("uniqueUsers") }}
        </AnalysisTableHeaderCell>
      </AnalysisTableHeaderRow>
    </template>
    <AnalysisTableRow v-for="(row, index) in data" :key="index">
      <AnalysisTableCell class="url-cell" width="50%">
        <div class="url-cell__wrapper">
          <a
            class="url-cell__external-link"
            :href="row.key.key"
            target="_blank"
            rel="noopener"
          >
            <IconButton
              :icon="icons.ExternalLink"
              :size="24"
              :icon-scale="0.5"
            />
          </a>
          <Tooltip
            class="url-cell__link-text"
            :text="row.title.forDisplay()"
            :placement="tooltipPlacement.TopStart"
          >
            <div>{{ row.key.forDisplay() }}</div>
          </Tooltip>
        </div>
      </AnalysisTableCell>
      <AnalysisTableCell class="number-cell">{{ row.count }}</AnalysisTableCell>
      <AnalysisTableCell class="number-cell">{{
        row.pvVisit
      }}</AnalysisTableCell>
      <AnalysisTableCell class="number-cell">{{
        row.uniqueUsers
      }}</AnalysisTableCell>
    </AnalysisTableRow>
  </AnalysisTable>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import { Icons } from "@/const/Icons";
import { TooltipPlacement } from "@/const/tooltip";
import Icon from "@/components/Icon.vue";
import IconButton from "@/components/IconButton.vue";
import Tooltip from "@/components/Tooltip.vue";
import AnalysisTable from "@/components/table/AnalysisTable.vue";
import AnalysisTableRow from "@/components/table/AnalysisTableRow.vue";
import AnalysisTableCell from "@/components/table/AnalysisTableCell.vue";
import AnalysisTableHeaderRow from "@/components/table/AnalysisTableHeaderRow.vue";
import AnalysisTableHeaderCell from "@/components/table/AnalysisTableHeaderCell.vue";
import { SegmentedTrendResult } from "@/models/segmented-trends/SegmentedTrendResult";

@Component({
  components: {
    Icon,
    IconButton,
    Tooltip,
    AnalysisTable,
    AnalysisTableRow,
    AnalysisTableCell,
    AnalysisTableHeaderRow,
    AnalysisTableHeaderCell
  }
})
export default class SegmentedTrendsWebViewTable extends Vue {
  tooltipPlacement = TooltipPlacement;
  icons = Icons;

  @Prop({ type: Array, required: true })
  data!: SegmentedTrendResult[];
}
</script>

<style scoped lang="scss">
.url-cell {
  padding-right: 0;
  padding-left: 0;
  text-align: left;

  @include all-break-word();
}
.url-cell__wrapper {
  display: table;
  min-width: 100px;
  width: 100%;
}
.url-cell__external-link {
  display: table-cell;
  padding-right: 5px;
  padding-left: 10px;
  width: 40px;
  vertical-align: middle;
  &:hover {
    text-decoration: none;
  }
}
.url-cell__link-text {
  display: table-cell;
  vertical-align: middle;
}
.number-cell {
  text-align: right;
}
</style>
